import React from 'react';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

import List from './List';

const ListaFeira = () => {
    document.title = "Lista de Feiras | EVOMAP - Tecnologia que conecta negócios";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Lista de Feiras" pageTitle="Feiras" />
                    <List />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ListaFeira;